<template>
    <main class="page__content">
        <!-- hero start -->
        <div class="hero">
            <div class="hero-background">
                <div class="hero-background__inner"></div>
            </div>
            <div class="hero-content">
                <div class="hero-content__inner">
                    <div class="hero-content__img">
                        <img src="@/assets/img/hero.png" alt="Velbert zeigt Herz" />
                    </div>
                    <div class="hero-content__text">
                        <h1>An wen wir spenden, entscheiden Sie!</h1>
                        <p>
                            Gemeinsam Gutes tun für die Region - Die Stadtwerke Velbert unterstützen gemeinnützige
                            Projekte in Velbert, denn wir wollen dort helfen, wo sich Bürger für Velbert stark machen.
                            <router-link class="cta-spendencode"
                                :to="{ name: 'RequestCode' }">Jetzt&nbsp;Spendencode&nbsp;anfordern!</router-link>
                        </p>
                        <!--
                            <h2>
                                Starthilfe für grüne Projekte
                            </h2>
                            <p>
                                <a @click="$emit('scroll-to', '#aktionsinhalt')" style="color: #fff; cursor: pointer;" class="cta-spendencode">
                                    Die Zukunft Velberts ist grün – nachhaltige Projekte starten 2024 mit Rückenwind!
                                </a>
                            </p>
                            -->
                    </div>
                </div>
            </div>
            <div class="hero-actions">
                <div class="hero-actions__inner">
                    <div class="hero-actions__wrapper">
                        <div class="hero-actions__show-projects">
                            <a @click="$emit('scroll-to', '#projects-overview')" class="btn btn--xl btn--green anchor" tabindex="0">
                                <strong>
                                    PROJEKTE ENTDECKEN <br>
                                </strong>
                                und Herzen vergeben
                            </a>
                        </div>
                        <div class="hero-actions__add-project">
                            <a @click="$emit('scroll-to', '#submit-project')" class="btn btn--xl btn--yellow anchor" tabindex="0">
                                <strong>
                                    PROJEKT EINREICHEN <br>
                                </strong>
                                und Spenden erhalten
                            </a>
                        </div>
                        <div class="hero-actions__enter-code">
                            <!-- code box start -->
                            <code-box :large="true">
                                <strong>
                                    CODE EINGEBEN<br>
                                </strong>
                                und Herzen spenden
                                <template slot="code">
                                    Verfügbare Herzen:
                                </template>
                            </code-box>
                            <!-- code box end -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- hero end -->

        <!-- message spent start -->
        <div class="message-spent">
            <!-- <h2>Sie haben 4 Projekte mit 533 € unterstützt.</h2> -->
            <h2>

                Sie haben {{ projects.length }} Projekte mit {{ getTotalDonationCount }} EUR unterstützt.
            </h2>
        </div>
        <!-- message spent end -->

        <!-- explain block projects start -->
        <div class="explain-block">
            <div class="explain-block__header">
                <h2>
                    <img src="@/assets/img/heart.png" alt="Velbert zeigt Herz"> Herzen verteilen: So funktioniert´s!
                </h2>
                <p>
                    Die Stadtwerke Velbert spenden und Sie entscheiden, welche Projekte wir unterstützen.
                </p>
            </div>
            <div class="explain-block-content">
                <div class="explain-block-content__inner">
                    <div class="explain-block-content__step explain-block-content__step--green">
                        <div>
                            <h3>1. Code einlösen</h3>
                            <p>Bitte geben Sie Ihren Spendencode oben im blauen Feld ein und bestätigen Sie diesen. Sie
                                gelangen
                                dann automatisch zu den Projekten.</p>
                            <h3 class="h5">Sie haben keinen Spendencode?</h3>
                            <p>
                                <router-link :to="{ name: 'RequestCode' }">Klicken Sie hier und fordern Sie Ihren
                                    Herz-Code
                                    an.</router-link>
                            </p>
                        </div>
                    </div>
                    <div class="explain-block-content__step explain-block-content__step--green">
                        <div>
                            <h3>2. Projekt auswählen</h3>
                            <p>Sie haben die Wahl! Suchen Sie sich ein oder mehrere Projekte aus, das bzw. die Ihnen am
                                Herzen
                                liegen. Klicken Sie auf den Button „zum Projekt“. Dort erhalten Sie alle Informationen
                                und
                                können Ihre Herzen spenden.</p>
                        </div>
                    </div>
                    <div class="explain-block-content__step explain-block-content__step--green">
                        <div>
                            <h3>3. Herzen verteilen</h3>
                            <p>Hier können Sie Ihre Herzen verteilen. Geben Sie die Anzahl Ihrer Herzen ein, mit denen
                                Sie
                                dieses Projekt fördern wollen, und klicken Sie auf den Button „Senden“. Sie können Ihre
                                Herzen
                                auf mehrere Projekte aufteilen. Wie viele Herzen Sie noch vergeben können, wird Ihnen
                                angezeigt.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="explain-block__subline">
                <h3>Sie haben die Möglichkeit, alle 30 Tage einen Code anzufordern. Also - anfordern und zwölfmal im
                    Jahr
                    Gutes tun.</h3>
            </div>
        </div>
        <!-- explain block projects end -->

        <!-- projects overview start -->
        <projects-overview />
        <!-- projects overview end -->

        <!-- projects map start -->
        <projects-map v-if="projects.length" />
        <!-- projects map end -->

        <!-- contact begin -->
        <div class="contact-block">
            <h3 class="contact-block__header">
                Sie haben noch Fragen?
            </h3>
            <p>
                Wenn Sie Fragen zu unserer Aktion <em>„Velbert zeigt Herz“</em> haben, melden Sie sich gerne bei uns:
            </p>
            <div class="contact-block__actions">
                <!-- <a href="tel:+492051988555">Telefon: 0 20 51-988-555</a> -->
                <a href="mailto:redaktion@velbert-zeigt-herz.de">E-Mail: redaktion@velbert-zeigt-herz.de</a>
            </div>
        </div>
        <!-- contact end -->

        <div class="contact-block contact-block--green">
            <h3 class="contact-block__header">
                Machen Sie
                <em>
                    Velbert zeigt Herz
                </em>
                bekannt!
            </h3>
            <div class="contact-block__actions">
                <a href="./static/velbert-zeigt-herz-plakat.pdf" download>
                    Hier finden Sie unser Plakat zum Herunterladen, Ausdrucken und Aushängen.
                </a>
            </div>
        </div>

        <!-- explain block projects start -->
        <div id="submit-project" class="explain-block">
            <div class="explain-block__header">
                <h2>
                    <img src="@/assets/img/heart.png" alt="Velbert zeigt Herz"> Projekt einreichen: So machen Sie mit!
                </h2>
                <p>
                    Sie brauchen Unterstützung für ein bestimmtes Projekt Ihrer sozialen Einrichtung oder Ihres Vereins?
                    <br>Dann reichen Sie Ihr Herzensprojekt bei uns ein.
                </p>
            </div>
            <div class="explain-block-content">
                <div class="explain-block-content__inner">
                    <div class="explain-block-content__step explain-block-content__step--yellow">
                        <div>
                            <h3>1. Projekt-Check</h3>
                            <p>Prüfen Sie, ob Ihr Projekt die Anforderungen für unsere Förderung erfüllt: Dient es einem
                                sozialen Zweck? Ist es für die Region Velbert? Ist Ihr Projekt bzw. Ihr Verein
                                gemeinnützig?
                                <router-link :to="{ name: 'ParticipationTerms' }" target="_blank">
                                    Erfahren Sie mehr.
                                </router-link>
                            </p>
                        </div>
                    </div>
                    <div class="explain-block-content__step explain-block-content__step--yellow">
                        <div>
                            <h3>2. Projekt-Erfassung</h3>
                            <p>Begeistern Sie möglichst viele Velberter für Ihre Herzensangelegenheit! Bei der Erfassung
                                Ihres
                                Projektes geben wir Ihnen hilfreiche Tipps, um möglichst viele Herzen zu sammeln.</p>
                        </div>
                    </div>
                    <div class="explain-block-content__step explain-block-content__step--yellow">
                        <div>
                            <h3>3. Projekt-Freigabe</h3>
                            <p>Sobald alle Daten von Ihnen vorliegen, prüfen wir Ihr Projekt und veröffentlichen es
                                schnellstmöglich. Bitte beachten Sie unsere <router-link
                                    :to="{ name: 'ParticipationTerms' }">Teilnahmebedingungen</router-link>. Ihr Projekt
                                wird erst
                                nach vollständiger Eingabe aller Daten geprüft. Viel Erfolg!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- explain block projects end -->

        <!-- submit project block start -->
        <submit-project />
        <!-- submit project block end -->
    </main>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import NavigateTo from '@/mixins/NavigateTo'

import ProjectsOverview from '@/components/ProjectsOverview'
import ProjectsMap from '@/components/ProjectsMap'
import SubmitProject from '@/components/SubmitProject'
import RequestCode from '@/components/RequestCode'
import CodeBox from '@/components/CodeBox'

export default {
    name: 'PageStart',

    mixins: [
        NavigateTo
    ],

    components: {
        ProjectsOverview,
        ProjectsMap,
        CodeBox,
        SubmitProject,
        RequestCode
    },

    computed: {
        ...mapState(['projects']),
        ...mapGetters(['getTotalDonationCount'])
    }
}
</script>



// WEBPACK FOOTER //
// src/components/PageStart.vue